module.exports = __webpack_public_path__ + "img/home.d65f903f.png";